import { Dialog, DialogContent, DialogActions, Button, Typography, DialogTitle } from '@mui/material';
import { FC, memo } from 'react';

type Props = {
  open: boolean;
  title?: string;
  message: string | React.ReactElement;
  handleOk: () => void;
  handleCancel: () => void;
}

export const ConfirmDialog: FC<Props> = memo(({ open, title, message, handleOk, handleCancel }) => (
  <Dialog
    sx={{ '& .MuiDialog-paper': { width: '80%', maxHeight: 435 } }}
    maxWidth="xs"
    open={open}
  >
    {title && (
      <DialogTitle>{title}</DialogTitle>
    )}
    <DialogContent dividers>
      <Typography>
        {message}
      </Typography>
    </DialogContent>
    <DialogActions>
      <Button onClick={handleCancel}>
        キャンセル
      </Button>
      <Button onClick={handleOk}>OK</Button>
    </DialogActions>
  </Dialog>
));
